import React from 'react';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import i18n from '../i18n/i18n';
import { AppRouter } from './AppRouter';
import { ErrorBoundary } from './common/errorBoundary/ErrorBoundary';
import { getQueryClientConfig } from '../utils/queryClientConfig';

import { getSession } from '../api/session/getSession';
import { initDatadogRum } from '../datadog/datadog-config';
import { getMembership } from '@/api/membership/getMembership';

initDatadogRum();

export const queryClient = new QueryClient(getQueryClientConfig());

export const Root = () => {
  queryClient.prefetchQuery({ queryKey: ['session'], queryFn: getSession });
  queryClient.prefetchQuery({ queryKey: ['membership'], queryFn: getMembership });
  return (
    <QueryClientProvider client={queryClient}>
      <I18nextProvider i18n={i18n}>
        <ErrorBoundary>
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
        </ErrorBoundary>
      </I18nextProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
};
